import React from 'react';
import Badge from '../atoms/Badge';
import Heading from '../atoms/Heading';
import Text from '../atoms/Text';
import Button from '../atoms/Button';

const HeroSection = ({
  badge,
  title,
  subtitle,
  description,
  primaryAction,
  secondaryAction,
  backgroundImage = "", // 背景画像は外部から指定
  backgroundClass = "bg-gradient-to-r from-gray-900 to-gray-700"
}) => {
  return (
    <section
      className={`relative py-20 ${backgroundClass}`}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-orange-900/30 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
        {badge && (
          <Badge variant="primary" size="medium" className="mb-6 backdrop-blur-sm bg-orange-500/90">
            {badge}
          </Badge>
        )}

        <Heading level={1} className="text-white mb-6 drop-shadow-lg">
          {title}
        </Heading>

        {subtitle && (
          <Text size="xl" className="max-w-3xl mx-auto mb-8 text-white font-semibold drop-shadow-lg">
            {subtitle}
          </Text>
        )}

        {description && (
          <Text size="lg" className="text-white max-w-2xl mx-auto mb-12 underline decoration-orange-400 drop-shadow-lg">
            {description}
          </Text>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {primaryAction && (
            <Button
              size="large"
              onClick={primaryAction.onClick}
              className="hover:-translate-y-1 hover:shadow-xl backdrop-blur-sm"
            >
              {primaryAction.text}
            </Button>
          )}
          {secondaryAction && (
            <Button
              variant="outline"
              size="large"
              onClick={secondaryAction.onClick}
              className="hover:-translate-y-1 backdrop-blur-sm border-white text-white hover:bg-white hover:text-gray-900"
            >
              {secondaryAction.text}
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;